import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import messages from '../../../locale/messages';
import style from './ScheduleSubtitle.scss';
import {customisedIntlFormatMessage} from '../../../utils/helpers';

const localMessages = defineMessages({
  shsSubtitleText: {
    id: 'schedule.ShsSubtitleText',
    defaultMessage:
      'Scheduling the Specialized High School Admissions Test allows you to apply for any of the following' +
      ' {number} programs',
    description: 'The SHS subtitle string',
    values: {
      number: 0,
    },
  },
  gtSubtitleText: {
    id: 'schedule.GTSubtitleText',
    defaultMessage: ` To participate in Gifted & Talented (G&T) admissions, your child will need to take the G&T test. Your child's score on this test determines eligibility for G&T programs. Register either to schedule your child's test or to find out when it will be offered.`,
    description: 'The GT subtitle string',
  },
  subtitleTextBeforeLink: {
    id: 'schedule.SubtitleTextBeforeLink',
    defaultMessage: 'If any programs you',
    description: 'The subtitle string appearing before the link if programs do not exist',
  },
  subtitleTextAfterLink: {
    id: 'schedule.SubtitleTextAfterLink',
    defaultMessage:
      'to your list require you to schedule an exam, audition, or other appointment, they will be listed here, along with the tools to schedule them.',
    description: 'The subtitle string appearing after the link if programs do not exist',
  },
  subtitleTextBeforeLinkProgramsExist: {
    id: 'schedule.SubtitleTextBeforeLinkProgramsExist',
    defaultMessage: 'Any programs you ',
    description: 'The subtitle string appearing before the link if programs exist',
  },
  subtitleTextAfterLinkProgramsExist: {
    id: 'schedule.SubtitleTextAfterLinkProgramsExist',
    defaultMessage:
      'to your list that require you to schedule an exam, audition, or other appointment are listed here, along with the tools to schedule them.',
    description: 'The subtitle string appearing after the link if programs exist',
  },
  subtitleTextMiddleSchoolFirstParagraph: {
    id: 'schedule.subtitleTextMiddleSchoolFirstParagraph',
    defaultMessage:
      'Mark Twain has two types of admissions assessments: virtual and in-person. You can apply for a maximum of two talent programs.',
    description: 'The first paragraph of the subtitle string appearing on Middle School schedule page',
  },
  subtitleTextMiddleSchoolSecondParagraph: {
    id: 'schedule.subtitleTextMiddleSchoolSecondParagraph',
    defaultMessage:
      'For the Art, Media, Strings, Winds, and Vocal programs, you will submit your audition materials virtually through the MySchools portal. You can upload videos, portfolios, or other required materials to the "Additional Materials" section located on your dashboard. The school will contact you directly if there are any callbacks.',
  },
  subtitleTextMiddleSchoolThirdParagraphPart1: {
    id: 'schedule.subtitleTextMiddleSchoolThirdParagraphPart1',
    defaultMessage:
      'Auditions for Dance and Drama will take place in-person at Mark Twain (2401 Neptune Avenue, Brooklyn, NY 11224). You must register for these auditions and add the program to your MySchools application to be considered.',
    description: 'The tihrd paragraph part 1 of the subtitle string appearing on Middle School schedule page',
  },
  subtitleTextMiddleSchoolThirdParagraphPart2: {
    id: 'schedule.subtitleTextMiddleSchoolThirdParagraphPart2',
    defaultMessage:
      'Additionally, talent tests for Computer Math, Creative Writing/Journalism, Science, and Athletics will be held in-person at the same location. Just like with auditions, you must register for the test and add the program to your application.',
    description: 'The tihrd paragraph part 2 of the subtitle string appearing on Middle School schedule page',
  },
  subtitleTextMiddleSchoolSecondParagraphHeader: {
    id: 'schedule.subtitleTextMiddleSchoolSecondParagraphHeader',
    defaultMessage:
      'Virtual Submissions',
    description: 'The second paragraph heading of the subtitle string appearing on Middle School schedule page',
  },
  subtitleTextMiddleSchoolThirdParagraphHeader: {
    id: 'schedule.subtitleTextMiddleSchoolThirdParagraphHeader',
    defaultMessage:
      'In-Person Auditions and Tests',
    description: 'The second paragraph heading of the subtitle string appearing on Middle School schedule page',
  },
});

const ScheduleSubtitle = ({ user, isSHS=false, programs={}, fullWidth=false, intl, sharedSchedules={} }) => {
const mark_twain_content = user?.details?.data?.mark_twain_content || '';
  if (!user.applicationId) {
    return null;
  }
  const addStyle = {};
  if (fullWidth) {
    addStyle.width = '100%';
  }

  const beforeText = programs.result
    ? localMessages.subtitleTextBeforeLinkProgramsExist
    : localMessages.subtitleTextBeforeLink;
  const linkText = programs.result ? messages.generalStringSave : messages.generalStringSaved;
  const afterText = programs.result
    ? localMessages.subtitleTextAfterLinkProgramsExist
    : localMessages.subtitleTextAfterLink;

  let subtitleText;
  if (user.isMS) {
    subtitleText = <div dangerouslySetInnerHTML={{ __html: sanitize_html(mark_twain_content) }}></div>;
  } else {
    subtitleText = (
      <span>
        {customisedIntlFormatMessage(intl, beforeText)}&nbsp;
        <a href={`/en/dashboard/${user.applicationId}/saves/`}>{customisedIntlFormatMessage(intl, linkText).toLowerCase()}</a>&nbsp;
        {customisedIntlFormatMessage(intl, afterText)}
      </span>
    );
  }

  // Cases are shared schedule SHS, shared schedule neither SHS or GT, and shared schedule GT
  return (
    <div className={style.scheduleSubtitle} style={addStyle}>
      {!isSHS && !user.isGT && sharedSchedules.loaded && subtitleText}
      {user.isGT &&
        sharedSchedules.loaded && (
          <div>
            <FormattedMessage {...localMessages.gtSubtitleText} />
          </div>
        )}
    </div>
  );
};

ScheduleSubtitle.propTypes = {
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  isSHS: PropTypes.bool,
  isGT: PropTypes.bool,
  programs: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  sharedSchedules: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  fullWidth: PropTypes.bool,
  intl: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.shape({}),
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default injectIntl(withStyles(style)(ScheduleSubtitle));
